var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ftue-button-container",class:{ 'ftue-button-container-large': _vm.button.isLarge },on:{"click":_vm.handleClick}},[_c('div',{staticClass:"ftue-button",class:{
      'ftue-button-large': _vm.button.isLarge,
      'ftue-button-enabled': !_vm.hasClicked
    },on:{"click":_vm.handleClick}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")])])}
var staticRenderFns = []
export { render, staticRenderFns }